export function getSaParameterFromUrl() {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('sa')
}
